import HTag from 'components/common/HTag'
import { Link } from 'gatsby'
import Img from 'components/common/Img'
import * as React from 'react'

export default function CaseStudyList({ heading, description, caseStudies }) {
	return (
		<section className="ctnr padding space-y-8">
			<header className="flex gap-4 <md:flex-col">
				<HTag className="h1 grow" {...heading} />
				{description && <p className="max-w-lg">{description}</p>}
			</header>

			<div className="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-4 md:gap-8">
				{caseStudies?.map((caseStudy) => (
					<article key={caseStudy._key}>
						<Link
							to={`/case-studies/${caseStudy.seo.slug.current}`}
							className="group block space-y-3"
						>
							<figure className="overflow-hidden transition-[filter] group-hover:brightness-110">
								<Img
									className="w-full grayscale"
									image={caseStudy.featuredImage}
									alt={caseStudy.seo.title}
								/>
							</figure>
							<h2 className="h4">{caseStudy.seo.title}</h2>
							<p>{caseStudy.seo.description}</p>
						</Link>
					</article>
				))}
			</div>
		</section>
	)
}
